import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import AuthShell from '../components/AuthShell';
import { apiFetch } from '../lib/api';

export default function Forgot() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [err,  setErr]  = useState<string | null>(null);

    async function onSubmit(e: React.FormEvent) {
        e.preventDefault();
        setErr(null); setBusy(true);
        try {
            await apiFetch('/api/auth/forgot', {
                method: 'POST', noAuth: true,
                body: { email: email.trim().toLowerCase() },
            });
            setDone(true);
        } catch (e) {
            setErr(t('auth.errors.unknown'));
        } finally { setBusy(false); }
    }

    return (
        <AuthShell
            eyebrow={t('brand.tagline')}
            title={t('auth.forgot.title')}
            subtitle={t('auth.forgot.sub')}
            backTo="/"
        >
            {done ? (
                <p className="text-center text-ink-on font-body py-6">{t('auth.forgot.sent')}</p>
            ) : (
                <form onSubmit={onSubmit} className="space-y-5" noValidate>
                    <label className="block">
                        <span className="field-label">{t('auth.emailLabel')}</span>
                        <input className="field-input" type="email" autoComplete="username"
                               value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </label>
                    {err && <div role="alert" className="text-sm text-ember pl-3 border-l-2 border-ember py-1">{err}</div>}
                    <button type="submit" className="btn btn-primary w-full" disabled={busy}>
                        {busy ? t('common.loading') : t('auth.forgot.cta')}
                    </button>
                </form>
            )}
            <div className="mt-6 text-center">
                <Link to="/" className="btn-link text-sm">{t('common.back')}</Link>
            </div>
        </AuthShell>
    );
}
